<div class="preview-modal">
  <div class="modal-header">
    <h2>{{documentName || 'Previsualización de Documento'}}</h2>
    <div class="actions">
      <ng-container *ngIf="data.draft">
        <button mat-raised-button color="primary" (click)="downloadDocumentPdf()">
          <mat-icon>archive</mat-icon>Descargar
        </button>
      </ng-container>
      <ng-container *ngIf="!viewOnly">
        <button mat-raised-button color="primary" (click)="openRequestSignatureModal()" *ngIf="!isSelectingLocation && signatureLocations.length === 0 && !this.companyDocument.isSignRequired && !viewOnly">
          Solicitar firma electrónica
        </button>
      </ng-container>
      <ng-container *ngIf="isSelectingLocation">
        <div class="location-selection-controls">
          <span class="selection-info">
            Seleccione la ubicación de la firma ({{signatureLocations.length}} seleccionadas)
          </span>
          <button mat-raised-button color="primary" (click)="finishLocationSelection()" [disabled]="signatureLocations.length === 0">
            Confirmar ubicaciones
          </button>
          <button mat-button (click)="cancelLocationSelection()">
            Cancelar
          </button>
        </div>
      </ng-container>
      <ng-container *ngIf="!isSelectingLocation && signatureLocations.length > 0">
        <div class="location-selection-controls">
          <span class="selection-info">
            Ubicaciones de firma registradas: {{signatureLocations.length}}
          </span>
          <button mat-raised-button color="primary" (click)="openRequestSignatureModal()">
            Agregar otro firmante
          </button>
        </div>
      </ng-container>
      <button mat-icon-button (click)="closeDialog()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <div class="modal-body">
    <div class="pdf-container" [class.selecting-location]="isSelectingLocation" *ngIf="!base64">
      <ngx-extended-pdf-viewer #pdfViewer
        [src]="pdfSrc"
        [height]="'100%'"
        [useBrowserLocale]="true"
        [textLayer]="true"
        [showUnverifiedSignatures]="true"
        [showToolbar]="false"
        [showSidebarButton]="false"
        [showFindButton]="false"
        [showPagingButtons]="true"
        [showZoomButtons]="true"
        [showPresentationModeButton]="false"
        [showOpenFileButton]="false"
        [showPrintButton]="false"
        [showDownloadButton]="false"
        [showBookmarkButton]="false"
        [showSecondaryToolbarButton]="false"
        [showRotateButton]="false"
        [showHandToolButton]="false"
        [showScrollingButton]="false"
        [showSpreadButton]="false"
        [showPropertiesButton]="false"
        [handTool]="isSelectingLocation"
        [zoom]="'page-width'"
        (pageChange)="onPageChange($event)"
        (zoomChange)="onZoomChange($event)"
        (click)="handlePdfClick($event)">
      </ngx-extended-pdf-viewer>
    </div>

    <div class="pdf-container" [class.selecting-location]="isSelectingLocation" *ngIf="base64">
      <ngx-extended-pdf-viewer #pdfViewer
        [base64Src]="base64"
        [height]="'100%'"
        [useBrowserLocale]="true"
        [textLayer]="true"
        [showUnverifiedSignatures]="true"
        [showToolbar]="false"
        [showSidebarButton]="false"
        [showFindButton]="false"
        [showPagingButtons]="true"
        [showZoomButtons]="true"
        [showPresentationModeButton]="false"
        [showOpenFileButton]="false"
        [showPrintButton]="false"
        [showDownloadButton]="false"
        [showBookmarkButton]="false"
        [showSecondaryToolbarButton]="false"
        [showRotateButton]="false"
        [showHandToolButton]="false"
        [showScrollingButton]="false"
        [showSpreadButton]="false"
        [showPropertiesButton]="false"
        [handTool]="isSelectingLocation"
        [zoom]="'page-width'"
        (pageChange)="onPageChange($event)"
        (zoomChange)="onZoomChange($event)"
        (click)="handlePdfClick($event)">
      </ngx-extended-pdf-viewer>
    </div>

    <div class="signatures-summary" *ngIf="signatureRequests.length > 0">
      <h3>Firmas solicitadas</h3>
      <div class="summary-item" *ngFor="let request of signatureRequests">
        <div class="signer-header">
          <div class="signer-info">
            <div class="name">{{request.nombre}}</div>
            <div class="details">
              <span class="rut">{{request.rut}}</span>
              <span class="separator">•</span>
              <span class="email">{{request.email}}</span>
              @switch (request.state) {
                @case(1)
                {
                  <span class="status signed">
                    <mat-icon matTooltip="Firmado" class="status-icon">task_alt</mat-icon>
                  </span>
                }
                @case(2)
                {
                  <span class="status rejected">
                    <mat-icon matTooltip="Cancelado" class="status-icon">cancel</mat-icon>
                  </span>
                }
                @default {
                  <span class="status pending">
                    <mat-icon matTooltip="Pendiente" class="status-icon">pending_actions</mat-icon>
                    <button mat-icon-button 
                    color="accent" 
                    (click)="requestSignatureLink(request)"
                    [disabled]="isSelectingLocation"
                    matTooltip="Solicitar link de firma"
                    class="request-link">
                      <mat-icon>link</mat-icon>
                    </button>    
                  </span>
                }
              }
            </div>
          </div>
          <div *ngIf="!this.companyDocument.isSignRequired">
            <button mat-icon-button 
                    color="primary" 
                    (click)="editSignatureLocations(request)"
                    [disabled]="isSelectingLocation"
                    matTooltip="Agregar ubicaciones de firma"
                    class="add-location" 
                  >
              <mat-icon>add_circle</mat-icon>
            </button>
            
          </div>
        </div>

        <div class="locations-list" *ngIf="getLocationsForSigner(request).length > 0">
          <div class="location" *ngFor="let location of getLocationsForSigner(request)">
            <div class="location-info">
              <mat-icon>gesture</mat-icon>
              <span>Firma {{location.index}} - Página {{location.page}}</span>
            </div>
            <button mat-icon-button 
                    color="warn" 
                    class="delete-location"
                    (click)="deleteSignatureLocation(location)"
                    [disabled]="isSelectingLocation"
                    matTooltip="Eliminar ubicación">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </div>
      </div>

      <div class="send-to-sign" *ngIf="!isSelectingLocation && !this.companyDocument.isSignRequired">
        <mat-form-field appearance="outline">
          <mat-select (selectionChange)="onChangeSigningType($event)" placeholder="Tipo de firma" [(value)]="selectedSigningType" [disabled]="isLoading">
            <mat-option *ngFor="let type of signingTypes" [value]="type.id">
              {{ type.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <button mat-raised-button 
                color="primary" 
                class="send-button"
                (click)="confirmSendToSign()"
                [disabled]="isLoading">
          <mat-spinner diameter="20" *ngIf="isLoading"></mat-spinner>
          <span *ngIf="!isLoading">
            <mat-icon>send</mat-icon>
            Enviar a firma
          </span>
        </button>
        <div class="warning-text">
          <mat-icon color="warn">warning</mat-icon>
          <span>Una vez enviado, no se podrán modificar las ubicaciones de firma</span>
        </div>
      </div>
    </div>
  </div>
</div>